module.exports = __webpack_public_path__ + "static/whole-life-insurance-hero-mobile.d957212a.webp";